export const nav = {
  home: 'Home',
  about: 'About',
  booking: 'Booking & Contact'
};

export const hero = {
  title1: 'Fish Ryders Surfcamp in Imsouane',
  subtitle1: 'Surf courses for all levels and ocean experiences in Morocco',
  title2: 'Progress with Karim, European certified coach',
  subtitle2: '15 years in Imsouane, 10 years teaching in Hossegor',
  title3: 'Surf trip and road trip in Morocco',
  subtitle3: 'The best spots according to conditions',
  cta1: 'Request a trip',
  cta2: 'Learn more'
};

export const values = {
  coaching: 'Certified Coaching',
  coachingDesc: 'European certified instructors with international experience',
  security: 'Safety and pedagogy',
  securityDesc: 'Professional approach adapted to all levels',
  spots: 'World-renowned spots',
  spotsDesc: 'Imsouane and the best spots on the Atlantic coast'
};

export const cta = {
  title: 'Ready to live the Fish Ryders experience?',
  subtitle: 'Join us in Imsouane for unforgettable surf sessions led by Karim, certified coach with 15 years of experience',
  bookNow: 'Book now',
  learnMore: 'Learn more'
};

export const why = {
  title: 'Why choose Fish Ryders?',
  subtitle: 'An authentic surfcamp in Imsouane, one of the best surf spots in Morocco',
  coach: 'Expert Coach',
  coachDesc: 'Karim, 15 years in Imsouane, European certified, former competitor',
  spots: 'Legendary Spots',
  spotsDesc: 'La Baie and Cathédrale, among the best waves in Africa',
  levels: 'All Levels',
  levelsDesc: 'Beginners to advanced, individual or group lessons',
  experiences: 'Unique Experiences',
  experiencesDesc: 'Paddle fishing, surfskate, dune trips, road trips'
};

export const footer = {
  description: 'Traveling surfcamp in Imsouane, Morocco. Surf courses for all levels, certified coaching and authentic ocean experiences.',
  navigation: 'Navigation',
  information: 'Information',
  home: 'Home',
  surfcamp: 'The Surfcamp',
  imsouane: 'Imsouane',
  stages: 'Surf Courses',
  activities: 'Activities',
  team: 'Team',
  accommodation: 'Accommodation',
  reservation: 'Booking',
  contact: 'Contact',
  rights: 'All rights reserved.',
  legal: 'Legal notice',
  privacy: 'Privacy policy',
  poweredBy: 'Powered by Readdy'
};

export const about = {
  badge: 'About',
  title: 'Discover Fish Ryders',
  subtitle: 'Traveling surfcamp in Imsouane, surf courses for all levels and authentic ocean experiences in Morocco'
};

export const surfcamp = {
  badge: 'The Surfcamp',
  title: 'Fish Ryders, traveling surfcamp in Imsouane',
  intro: 'Fish Ryders is a traveling surfcamp based in Imsouane, a former fishing village located on Morocco\'s Atlantic coast between Essaouira and Agadir.',
  paragraph1: 'Karim leads surf courses and also offers paddle sport fishing, surfskate and dune trips for a complete experience of the ocean and Moroccan desert.',
  paragraph2: 'Our approach emphasizes authenticity, safety and respect for the environment, in an exceptional setting where passion for surfing meets local culture.',
  location: 'Imsouane, Morocco',
  traveling: 'Traveling Surfcamp',
  allLevels: 'All Levels'
};

export const imsouane = {
  badge: 'The Spots',
  title: 'Imsouane and its legendary waves',
  subtitle: 'Discover the mythical spots of Imsouane and explore the best breaks on the Moroccan Atlantic coast',
  bayName: 'La Baie',
  bayLevel: 'Beginners & Intermediates',
  bayDesc: 'Long and gentle wave, perfect for learning and progressing safely',
  cathedralName: 'La Cathédrale',
  cathedralLevel: 'Advanced & Confirmed',
  cathedralDesc: 'Powerful and technical point break for experienced surfers',
  travelingName: 'Traveling Sessions',
  travelingLevel: 'All Levels',
  travelingDesc: 'Van trips to the best spots within a 1-hour radius depending on conditions',
  longestWaves: 'The longest waves in Africa',
  longestWavesDesc: 'Up to 800 meters of glide on Imsouane Bay'
};

export const coach = {
  badge: 'Your Coach',
  title: 'Karim, passionate ocean expert',
  intro1: 'Originally from Skhirat south of Rabat, Karim has been surfing in Imsouane for 15 years and knows every wave, every current, every secret of this legendary spot.',
  intro2: 'Surf coach every summer in France for 10 years in Hossegor, he holds European surf and kitesurf instructor diplomas, guaranteeing international quality teaching.',
  intro3: 'Former competitor and fishing enthusiast, Karim shares his deep knowledge of the ocean with authenticity and pedagogy, for fast and safe progression.',
  formerCompetitor: 'Former competitor',
  europeanDiplomas: 'European surf & kite diplomas',
  imsouaneYears: '15 years in Imsouane',
  hossegorYears: '10 years in Hossegor'
};

export const stages = {
  badge: 'Surf Courses',
  title: 'Progress at your own pace',
  subtitle: 'Courses and sessions for all levels, individual or group, for all ages in Imsouane bay and on renowned spots in the region',
  privateTitle: 'Private Lessons',
  privateDesc: 'Personalized coaching for fast and targeted progression',
  groupTitle: 'Group Lessons',
  groupDesc: 'Friendly atmosphere and sharing among enthusiasts',
  roadTripTitle: 'Road Trip',
  roadTripDesc: 'From Skhirat to Taghazout, explore the best spots',
  sessionTitle: 'Typical session breakdown',
  step1Title: 'Safety',
  step1Desc: 'Complete briefing on safety rules and equipment',
  step2Title: 'Water knowledge',
  step2Desc: 'Analysis of conditions, currents and surf zones',
  step3Title: 'Warm-up',
  step3Desc: 'Adapted physical preparation before entering the water',
  step4Title: 'Wave reading and accompanied surfing',
  step4Desc: 'Real-time coaching in the water for optimal progression',
  step5Title: 'Report and feedback',
  step5Desc: 'Personalized debriefing and advice to progress'
};

export const activities = {
  badge: 'Activities',
  title: 'Much more than surfing',
  subtitle: 'A complete experience between ocean, culture and Moroccan adventure',
  surfTitle: 'Surf',
  surfDesc: 'Equipment rental, individual or group lessons, weekly courses',
  fishingTitle: 'Paddle Sport Fishing',
  fishingDesc: 'Discover stand-up paddle fishing with Karim, ocean enthusiast',
  surfskateTitle: 'Surfskate',
  surfskateDesc: 'Surfskate sessions in front of Cathédrale to improve your technique',
  dunesTitle: 'Dune Trips',
  dunesDesc: 'Sand surfing in the dunes, fish tagine and traditional Moroccan tea'
};

export const team = {
  badge: 'Our Team',
  title: 'A team of enthusiasts at your service',
  intro1: 'Our team is composed of local and international enthusiasts, all united by love for the ocean and surfing.',
  intro2: 'All our instructors are certified and have recognized expertise in water safety, guaranteeing professional and reassuring supervision for all levels.',
  intro3: 'We favor a human and personalized approach, where each trainee benefits from special attention to progress in the best conditions.',
  certifiedInstructors: 'Certified instructors',
  yearsExperience: 'Years of experience'
};

export const accommodation = {
  badge: 'Accommodation',
  title: 'Find your accommodation',
  subtitle: 'Accommodation is the responsibility of trainees. We help you find the ideal accommodation according to your preferences and budget',
  guesthousesTitle: 'Guest Houses',
  guesthousesDesc: 'Authentic accommodations with locals',
  apartmentsTitle: 'Apartments',
  apartmentsDesc: 'Fully equipped studios and apartments',
  hotelsTitle: 'Hotels',
  hotelsDesc: 'Comfortable options for all budgets',
  helpTitle: 'Need help booking?',
  helpDesc: 'Our team assists you in finding and booking your accommodation in Imsouane. Authentic guest houses, comfortable apartments or hotels, we know the best addresses in the village.',
  askHelp: 'Ask for help'
};

export const booking = {
  badge: 'Booking & Contact',
  heroTitle: 'Book your surf adventure',
  heroSubtitle: 'Choose your package and contact us for any questions',
  
  // Booking
  reservationBadge: 'Booking',
  reservationTitle: 'Book your course',
  reservationSubtitle: 'Fill out the form below to book your surf course',
  
  lastName: 'Last Name',
  firstName: 'First Name',
  email: 'Email',
  emailPlaceholder: 'your@email.com',
  phone: 'Phone',
  phonePlaceholder: '+212 6XX XXX XXX',
  whatsapp: 'WhatsApp',
  whatsappPlaceholder: '+212 6XX XXX XXX',
  level: 'Surf Level',
  selectLevel: 'Select your level',
  beginner: 'Beginner',
  initiated: 'Initiated',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
  confirmed: 'Confirmed',
  formula: 'Package',
  selectFormula: 'Select a package',
  privateLesson: 'Private lesson',
  groupLesson: 'Group lesson',
  weekStage: 'Week course',
  roadTrip: 'Road trip',
  startDate: 'Start Date',
  endDate: 'End Date',
  numberOfPeople: 'Number of People',
  accommodation: 'Accommodation',
  selectAccommodation: 'Select accommodation',
  noAccommodation: 'No, I manage my accommodation',
  guesthouse: 'Yes, guesthouse',
  apartment: 'Yes, apartment',
  hotel: 'Yes, hotel',
  message: 'Message',
  messagePlaceholder: 'Tell us about your expectations, specific needs...',
  charactersCount: 'characters',
  submitReservation: 'Send my booking',
  continuePayment: 'Continue to payment',
  requiredFields: '* Required fields',
  
  // Contact
  contactBadge: 'Contact',
  contactTitle: 'Contact us',
  contactSubtitle: 'A question? A course or road trip project? Feel free to contact us',
  fullName: 'Full Name',
  fullNamePlaceholder: 'Your full name',
  levelPlaceholder: 'Select your level',
  desiredDates: 'Desired Dates',
  datesPlaceholder: 'E.g.: July 15-20, 2024',
  yourMessage: 'Your Message',
  messagePlaceholderContact: 'Ask us your questions...',
  sendMessage: 'Send message',
  sending: 'Sending...',
  successMessage: 'Message sent successfully!',
  errorMessage: 'An error occurred. Please try again.',
  
  // Contact information
  contactInfo: 'Contact Information',
  meetingPoint: 'Meeting Point',
  surfShop: 'Surfshop village center',
  imsouaneAddress: 'Imsouane, Morocco',
  telephone: 'Phone',
  emailLabel: 'Email',
  followUs: 'Follow Us',
  followUsDesc: 'Join our community on social media to follow our adventures and discover our best spots'
};

export const legal = {
  title: 'Legal Notice',
  editorTitle: 'Website Publisher',
  company: 'Company',
  director: 'Director',
  siret: 'SIRET',
  contact: 'Contact',
  hostingTitle: 'Hosting',
  hostingProvider: 'Host Provider',
  website: 'Website',
  propertyTitle: 'Intellectual Property',
  propertyText: 'All content on this site (texts, images, videos, logos) is the exclusive property of IB CONSEIL or its partners. Any reproduction, distribution, modification or use without prior authorization is strictly prohibited and constitutes counterfeiting sanctioned by the Intellectual Property Code.',
  responsibilityTitle: 'Liability',
  responsibilityText: 'IB CONSEIL strives to ensure the accuracy and updating of information published on this site. However, IB CONSEIL cannot guarantee the accuracy, precision or completeness of the information made available. Consequently, IB CONSEIL disclaims all liability for any inaccuracy, inaccuracy or omission relating to information available on this site.',
  linksTitle: 'Hyperlinks',
  linksText: 'The site may contain links to other sites. IB CONSEIL exercises no control over these sites and disclaims all liability for their content. The existence of a link to another site does not constitute validation of that site or its content.',
  lawTitle: 'Applicable Law',
  lawText: 'These legal notices are governed by French law. In the event of a dispute and in the absence of an amicable agreement, the dispute will be brought before the French courts in accordance with the rules of jurisdiction in force.'
};

export const privacy = {
  title: 'Privacy Policy',
  introTitle: 'Introduction',
  introText: 'IB CONSEIL, represented by its director Ilan Boutboul, attaches great importance to the protection of your personal data. This privacy policy informs you about how we collect, use and protect your personal information in accordance with the General Data Protection Regulation (GDPR).',
  collectionTitle: 'Data Collected',
  collectionIntro: 'We collect the following personal data when you use our site:',
  collectionItem1: 'Identity information: last name, first name',
  collectionItem2: 'Contact details: email address, phone number, WhatsApp',
  collectionItem3: 'Booking information: dates, surf level, chosen package, number of people',
  collectionItem4: 'Messages and communications you send us',
  useTitle: 'Use of Data',
  useIntro: 'Your personal data is used to:',
  useItem1: 'Process your booking and contact requests',
  useItem2: 'Provide you with the requested services',
  useItem3: 'Send you information related to your booking',
  useItem4: 'Improve our services and your user experience',
  protectionTitle: 'Data Protection',
  protectionText: 'We implement appropriate technical and organizational security measures to protect your personal data against unauthorized access, modification, disclosure or destruction. Your data is stored securely and is only accessible to authorized persons.',
  cookiesTitle: 'Cookies',
  cookiesText: 'Our site uses cookies to improve your browsing experience. Cookies are small text files stored on your device. You can configure your browser to refuse cookies, but this may affect certain site features.',
  rightsTitle: 'Your Rights',
  rightsIntro: 'In accordance with GDPR, you have the following rights:',
  rightsItem1: 'Right of access: you can request access to your personal data',
  rightsItem2: 'Right of rectification: you can request correction of inaccurate data',
  rightsItem3: 'Right to erasure: you can request deletion of your data',
  rightsItem4: 'Right to object: you can object to the processing of your data',
  rightsContact: 'To exercise these rights, contact us at: contact@fishryders.com',
  contactTitle: 'Contact',
  contactDirector: 'Director',
  updatesTitle: 'Updates',
  updatesText: 'We reserve the right to modify this privacy policy at any time. Changes take effect as soon as they are published on this page. We encourage you to regularly consult this page to stay informed of our data protection practices.'
};
